import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const KEY = "gefion_consent_v1";
const Ctx = createContext(null);

const DEFAULT = { essential: true, analytics: false, marketing: false, accepted_at: null };

// PostHog is loaded but auto-init is skipped in index.html; we call it after consent
const enableAnalytics = () => {
  try {
    if (window.posthog && !window.__ph_enabled) {
      window.__ph_enabled = true;
      window.posthog.opt_in_capturing();
    }
  } catch {}
};
const disableAnalytics = () => {
  try { if (window.posthog) window.posthog.opt_out_capturing(); } catch {}
};

export function ConsentProvider({ children }) {
  const [prefs, setPrefs] = useState(DEFAULT);
  const [showBanner, setShowBanner] = useState(false);
  const [customizing, setCustomizing] = useState(false);

  useEffect(() => {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || "null");
      if (s?.accepted_at) {
        setPrefs(s);
        if (s.analytics) enableAnalytics(); else disableAnalytics();
      } else {
        setShowBanner(true);
        disableAnalytics();
      }
    } catch { setShowBanner(true); }
  }, []);

  const save = useCallback(async (next) => {
    const withTs = { ...next, accepted_at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(withTs));
    setPrefs(withTs);
    setShowBanner(false);
    setCustomizing(false);
    if (withTs.analytics) enableAnalytics(); else disableAnalytics();
    try { await api.post("/privacy/consent-log", { kind: "cookie", prefs: withTs }); } catch {}
  }, []);

  const acceptAll = () => save({ essential: true, analytics: true, marketing: false });
  const rejectAll = () => save({ essential: true, analytics: false, marketing: false });
  const open = useCallback(() => { setCustomizing(true); setShowBanner(true); }, []);

  return (
    <Ctx.Provider value={{ prefs, showBanner, customizing, acceptAll, rejectAll, save, open, setCustomizing }}>
      {children}
    </Ctx.Provider>
  );
}

export const useConsent = () => useContext(Ctx);
